var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzureSmallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0415 5.8801H17.7235L11.825 23.3875C11.7644 23.5674 11.649 23.7238 11.495 23.8345C11.341 23.9453 11.1563 24.0048 10.9668 24.0049H6.54476C6.40115 24.0049 6.2596 23.9707 6.13182 23.905C6.00405 23.8393 5.89371 23.7441 5.80995 23.6273C5.72618 23.5104 5.67139 23.3753 5.65012 23.233C5.62884 23.0907 5.64169 22.9454 5.6876 22.8091L11.183 6.49744C11.2436 6.31747 11.359 6.16107 11.513 6.05028C11.6671 5.93949 11.8519 5.88011 12.0415 5.8801Z",
    fill: "url(#paint0_linear_334_5672)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2553 17.9634H10.9063C10.8194 17.9633 10.7345 17.9871 10.6626 18.0318C10.5907 18.0765 10.5352 18.1399 10.5033 18.2138C10.4714 18.2877 10.4646 18.3686 10.4838 18.4461C10.503 18.5236 10.5473 18.594 10.6108 18.6482L16.6183 23.7731C16.7932 23.9222 17.0235 24.0051 17.2627 24.005H22.5565L20.2553 17.9634Z",
    fill: "#0078D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0644 5.87989C11.872 5.87915 11.6844 5.93983 11.529 6.05306C11.3736 6.16629 11.2586 6.32614 11.2007 6.50926L5.6934 22.7942C5.64423 22.931 5.62879 23.0777 5.64839 23.2217C5.668 23.3657 5.72207 23.5029 5.80604 23.6217C5.89001 23.7404 6.0014 23.8372 6.13079 23.9039C6.26019 23.9706 6.40378 24.0053 6.54941 24.0049H11.1026C11.2722 23.9746 11.4307 23.9 11.5619 23.7886C11.6931 23.6773 11.7924 23.5331 11.8495 23.3709L12.9478 20.1405L16.8708 23.7924C17.0352 23.9281 17.2414 24.0031 17.4547 24.0049H22.5568L20.3191 17.6228L13.7959 17.6244L17.7883 5.87989H12.0644Z",
    fill: "url(#paint1_linear_334_5672)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1869 6.49635C19.1237 6.31666 19.0034 6.16052 18.8428 6.04993C18.6823 5.93934 18.4897 5.87986 18.2921 5.87988H11.6816C11.8792 5.87989 12.0719 5.93938 12.2324 6.04997C12.3929 6.16056 12.5132 6.31668 12.5764 6.49635L18.3133 22.8087C18.3612 22.945 18.3747 23.0903 18.3525 23.2327C18.3303 23.375 18.2731 23.5102 18.1857 23.6271C18.0982 23.744 17.983 23.8392 17.8496 23.9049C17.7162 23.9706 17.5684 24.0049 17.4185 24.0049H24.0291C24.1791 24.0048 24.3268 23.9705 24.4602 23.9048C24.5936 23.8391 24.7087 23.7439 24.7962 23.627C24.8836 23.5101 24.9407 23.3749 24.9629 23.2326C24.9851 23.0903 24.9717 22.945 24.9237 22.8087L19.1869 6.49635Z",
    fill: "url(#paint2_linear_334_5672)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_334_5672",
    x1: 14.1124,
    y1: 7.22321,
    x2: 8.19277,
    y2: 24.6804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_334_5672",
    x1: 15.9933,
    y1: 15.3616,
    x2: 14.6238,
    y2: 15.8256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.321,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.623,
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_334_5672",
    x1: 14.9134,
    y1: 6.71364,
    x2: 21.2018,
    y2: 24.1716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureSmallIcon);
export default __webpack_public_path__ + "static/media/azure-small-icon.318118cbc065957185c0c3717e74f1f5.svg";
export { ForwardRef as ReactComponent };